import { render, staticRenderFns } from "./ProjectReportDetails.vue?vue&type=template&id=fdd17618&scoped=true"
import script from "./ProjectReportDetails.vue?vue&type=script&lang=js"
export * from "./ProjectReportDetails.vue?vue&type=script&lang=js"
import style0 from "./ProjectReportDetails.vue?vue&type=style&index=0&id=fdd17618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd17618",
  null
  
)

export default component.exports